import * as i18n from "util/i18n";

const PASSWORD_RULE_KEYS = [
    "settings.changePassword.passwordHelp.rule1",
    "settings.changePassword.passwordHelp.rule2",
    "settings.changePassword.passwordHelp.rule3",
    "settings.changePassword.passwordHelp.rule4",
    "settings.changePassword.passwordHelp.rule5",
];

const USERPASS_RULE_KEYS = [
    "settings.changeUserpass.userPassHelp.rule1",
    "settings.changeUserpass.userPassHelp.rule2",
    "settings.changeUserpass.userPassHelp.rule3",
    "settings.changeUserpass.userPassHelp.rule4",
    "settings.changeUserpass.userPassHelp.rule5",
];

/**
 * Textos de reglas de contraseña (mismo criterio que PasswordHelp en flujo clásico).
 */
export function buildPasswordCredentialFormatRules(minLength, maxLength) {
    const params = { MIN_LENGTH: minLength, MAX_LENGTH: maxLength };
    return PASSWORD_RULE_KEYS.map((key) => i18n.get(key, null, params));
}

/**
 * Textos de reglas de nombre de usuario (mismo criterio que alta de usuario en enrollment).
 */
export function buildUserpassCredentialFormatRules(minLength, maxLength) {
    const params = { MIN_LENGTH: minLength, MAX_LENGTH: maxLength };
    return USERPASS_RULE_KEYS.map((key) => i18n.get(key, null, params));
}
